const patterns = {
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    phoneNumber: /^\d{3}-\d{3}-\d{4}$/,
    date: /^\d{2}\/\d{2}\/\d{4}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
    numbers: /^[0-9]*$/
};

export default patterns;